<template>
    <div>
        <div v-if="this.loading" class="loaderContainer">
            <dot-loader></dot-loader>
        </div>
        <DashboardFavoriteBar v-if="!this.loading"
                              :medium="vuexState.campaign.campaign.mediums[this.mediumIndex]"></DashboardFavoriteBar>
        <div v-if="!this.loading">
            <tabs class="tabbar" @tabSelected="changeMediumIndex">
                <tab v-for="(medium, index) in vuexState.campaign.campaign.mediums"
                     :name="medium.type + ' ' + (medium.name?medium.name:'')"
                     :selected="index===0" :key="'tab-no-'+index" :device-type="medium.type" :index="index">
                </tab>
            </tabs>
            <div class="dashboardContent">
                <carousel :key="'carousel-'+this.mediumIndex" @afterSlideChange="changeInsertionOrderIndex">
                    <slide
                        v-for="(item, index) in vuexState.campaign.campaign.mediums[this.mediumIndex].insertion_order"
                        :index="index" :key="`io-0-${index}`">
                        <div class="current-text slider-insertion-header">Platzierung</div>
                        <div class="current-text-main">{{ getCarouselSlideName(index) }}</div>
                        <div v-tooltip.bottom="getSites(item)" class="icon icon-info current-text slider-info"></div>
                    </slide>
                </carousel>
                <div v-if="!this.formulaReady" class="loaderContainer">
                    <dot-loader></dot-loader>
                </div>
                <div v-if="this.formulaReady">
                    <div class="kpiContainer">
                        <div class="kpiWrapper large">
                            <DashboardKPIBox
                                :title="'Ad Impressions'"
                                :value="getAdImpressions"
                                :color="'pink'"
                                :icon="'icon-visible'"
                                :info-text="(medium.type === 'Online' ? 'Desktop: '+getDesktopAdImpressions+', Tablet: '+getTabletAdImpressions:'')"
                            >

                            </DashboardKPIBox>
                        </div>
                        <div class="kpiWrapper">
                            <DashboardKPIBox
                                :title="'Click Rate'"
                                :value="getTotalClickRate"
                                :color="'blue'"
                                icon="icon-interactions"
                                :info-text="(typeof findInFormulas('Gesamt-Klickrate').pivot !== 'undefined' ? findInFormulas('Gesamt-Klickrate').pivot.comment : '')"
                            ></DashboardKPIBox>
                        </div>
                        <div class="kpiWrapper">
                            <DashboardKPIBox
                                :title="'Interaction Rate'"
                                :value="getInteractionRate"
                                :color="'blue'"
                                :icon="'icon-interactions'"
                                :info-text="(typeof findInFormulas('Interaction Rate').pivot !== 'undefined' ? findInFormulas('Interaction Rate').pivot.comment : '')"
                                :flip-background="true"></DashboardKPIBox>
                        </div>
                    </div>
                    <div class="progressbar-wrapper">
                        <div class="progress-infos">
                            <span class="campaign-progress">Kampagnenfortschritt</span>
                            <span class="campaign-status">Status: {{ this.vuexState.campaign.campaign.status }}</span>
                        </div>
                        <div class="progressbar">
                            <DashboardProgressbar :progress="progress"></DashboardProgressbar>
                        </div>
                    </div>
                    <ChartGrid :comment="comment" :is-editable="isEditable" :formula-ready="this.formulaReady"
                               :formulas="formulas" :insertionOrderIndex="insertionOrderIndex"
                               :mediumIndex="mediumIndex"
                               :engagement-hash="engagementHash" :sites="sites"></ChartGrid>
                </div>
                <DashboardCommentSection :comment="comment" :campaign="vuexState.campaign.campaign"
                                         :editable="isEditable"
                                         @input="updateComment"></DashboardCommentSection>
                <DashboardAttachment :editable="isEditable" id="attachment-area" :medium="medium"></DashboardAttachment>

            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../../../scripts/utils';
import DashboardKPIBox from "../DashboardKPIBox";
import DashboardProgressbar from "../DashboardProgressbar";
import Carousel from "../../../components/carousel/Carousel";
import Slide from "../../../components/carousel/Slide";
import Tabs from "../../../components/tablist/basicTabs/Tabs";
import Tab from "../../../components/tablist/basicTabs/Tab";
import DashboardAttachment from "../DashboardAttachement";
import DashboardFavoriteBar from "../DashboardFavoriteBar";
import DashboardCommentSection from "../DashboardCommentSection";
import ChartGrid from "../ChartGrid";
import moment from 'moment';

export default {
    name: "ShowDashboard",
    components: {
        // OverflowTabs,
        ChartGrid,
        DashboardCommentSection,
        DashboardFavoriteBar,
        DashboardAttachment,
        Slide,
        Carousel,
        DashboardProgressbar,
        DashboardKPIBox,
        Tab,
        Tabs
    },
    data: function () {
        return {
            formulaReady: false,
            loading: true,
            mediumIndex: 0,
            insertionOrderIndex: 0,
            progress: 0,
            comment: '',
            isEditable: false,
            mediumChangePending: false
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === null) {
            return next();
        }
        if (typeof to.meta.edited === 'undefined') {
            let meta = to.meta;
            meta.edited = true;
            next({
                path: to.path,
                query: from.query,
                meta: meta
            })
        } else {
            if (typeof to.meta.edited !== 'undefined') {
                delete to.meta.edited;
            }
            next();
        }
    },
    mounted() {
        if (this.$route.name === 'showDashboard' || this.$route.name === 'showReporting') {
            this.$store.dispatch('campaign/fetch', this.$route.params.id).then(() => {
                this.comment = this.vuexState.campaign.campaign.comment;
                this.$store.dispatch('trackingList/fetch', this.vuexState.campaign.campaign.mediums[0].tracking_list_id).then(() => {
                    this.loading = false;
                    setTimeout(function () {
                        this.progress = this.getProgress();
                    }.bind(this), 200);
                    this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                        if (!this.mediumChangePending) {
                            this.formulaReady = true;
                        }
                    });
                });
            });
        } else {
            this.loading = false;
        }
        this.updateEditable();
        window.addEventListener('resize', this.updateEditable);
    },
    computed: {
        vuexState() {
            return this.$store.state;
        },
        formulas() {
            this.formulaReady;
            return this.$store.getters['trackingList/formulas'];
        },
        insertionOrder() {
            return this.vuexState.campaign.campaign.mediums[this.mediumIndex].insertion_order[this.insertionOrderIndex];
        },
        medium() {
            return this.vuexState.campaign.campaign.mediums[this.mediumIndex]
        },
        getAdImpressions() {
            //let reporting = this.$store.getters['trackingList/reporting'];
            if (typeof this.insertionOrder.line_items === "undefined") {
                return '...';
            } else {
                return Utils.calcImpressions(this.insertionOrder.line_items, this.vuexState.trackingList.data.medium.type).totalAIs.toLocaleString('de-DE') + ' AIs';
            }
        },
        getDesktopAdImpressions() {
            //let reporting = this.$store.getters['trackingList/reporting'];
            if (typeof this.insertionOrder.line_items === "undefined") {
                return '...';
            } else {
                return Utils.calcImpressions(this.insertionOrder.line_items, this.vuexState.trackingList.data.medium.type).desktopAIs.toLocaleString('de-DE') + ' AIs';
            }
        },
        getTabletAdImpressions() {
            //let reporting = this.$store.getters['trackingList/reporting'];
            if (typeof this.insertionOrder.line_items === "undefined") {
                return '...';
            } else {
                return Utils.calcImpressions(this.insertionOrder.line_items, this.vuexState.trackingList.data.medium.type).tabletAIs.toLocaleString('de-DE') + ' AIs';
            }
        },
        getTotalClickRate() {
            let reporting = this.getReporting('gesamt-klickrate');
            return !reporting ? '0.00 %' : reporting.relation;
        },
        getInteractionRate() {
            let reporting = this.getReporting('interaction rate');
            return !reporting ? '0.00 %' : reporting.relation;
        },
        engagementHash() {
            return this.insertionOrder.engagement_hash;
        },
        sites() {
            let arr = [];
            for (let i = 0; i < this.insertionOrder.sites.length; i++) {
                if (typeof this.insertionOrder.sites[i].parent_name !== 'undefined' && this.insertionOrder.sites[i].parent_name) {
                    arr.push(this.insertionOrder.sites[i].parent_name + ' ' + this.insertionOrder.sites[i].name);
                } else {
                    arr.push(this.insertionOrder.sites[i].name);
                }
            }
            return arr;
        }
    },
    methods: {
        updateEditable() {
            if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                this.isEditable = false;
            } else {
                this.isEditable = typeof this.$route.query.key === 'undefined';
            }
        },
        getReporting(name) {
            let hash_key = this.engagementHash + '_' + this.insertionOrder.id;
            for (let index = 0; index < this.formulas.length; index++) {
                if (this.formulas[index].name.toLowerCase() === name.toLowerCase()) {
                    if (typeof this.formulas[index].reporting[hash_key] !== 'undefined' && this.formulas[index].reporting[hash_key].sites.length > 0) {
                        this.noData = false;
                        return this.formulas[index].reporting[hash_key].sites[this.insertionOrderIndex];
                    } else {
                        this.noData = true;
                        break;
                    }

                }
            }
            return {
                relation: 0,
                count: 0
            };
        },
        findInFormulas(name) {
            for (let i = 0; i < this.formulas.length; i++) {
                if (this.formulas[i].name === name) {
                    return this.formulas[i];
                }
            }
            return {};
        },
        getShortForm(insertionOrderType) {
            let ret = '';
            switch (insertionOrderType) {
                case 'Run of Channel':
                    ret = 'RoC';
                    break;
                case 'Run of Site':
                    ret = 'RoS';
                    break;
                case 'Festplatzierung':
                    ret = 'FP';
                    break;
                default:
                    ret = insertionOrderType;
                    break;
            }
            return ret;
        },
        getSites(insertionOrder) {
            let ret = [];
            for (let i = 0; i < insertionOrder.sites.length; i++) {
                if (typeof insertionOrder.sites[i].parent_name !== 'undefined' && insertionOrder.sites[i].parent_name) {
                    ret.push(insertionOrder.sites[i].parent_name + ' ' + insertionOrder.sites[i].name);
                } else {
                    ret.push(insertionOrder.sites[i].name);
                }

            }
            return ret.join(', ')
        },
        changeMediumIndex(mediumIndex) {
            this.mediumChangePending = true;
            this.mediumIndex = mediumIndex;
            this.insertionOrderIndex = 0;
            this.fetchTrackingList();
        },
        getCarouselSlideName(insertionOrderIndex) {
            let insertionOrder = this.vuexState.campaign.campaign.mediums[this.mediumIndex].insertion_order;
            let rocCount = 0;
            let rosCount = 0;
            let fpCount = 0;
            for (let i = 0; i < insertionOrder.length; i++) {
                if (i === insertionOrderIndex) {
                    if (insertionOrder[i].type === 'Run of Site') {
                        return insertionOrder[i].name ? insertionOrder[i].name : rosCount > 0 ? insertionOrder[i].type + ' #' + (rosCount + 1) : insertionOrder[i].type;
                    } else if (insertionOrder[i].type === 'Run of Channel') {
                        return insertionOrder[i].name ? insertionOrder[i].name : rocCount > 0 ? insertionOrder[i].type + ' #' + (rocCount + 1) : insertionOrder[i].type;
                    } else {
                        if (typeof insertionOrder[i].sites[0] !== 'undefined' && insertionOrder[i].sites.length === 1) {
                            if (typeof insertionOrder[i].sites[0].parent_name !== 'undefined' && insertionOrder[i].sites[0].parent_name) {
                                return insertionOrder[i].name ? insertionOrder[i].name : insertionOrder[i].sites[0].parent_name + ' ' + insertionOrder[i].sites[0].name;
                            }
                            return insertionOrder[i].name ? insertionOrder[i].name : insertionOrder[i].sites[0].name;
                        }
                        return insertionOrder[i].name ? insertionOrder[i].name : fpCount > 0 ? insertionOrder[i].type + ' #' + (fpCount + 1) : insertionOrder[i].type;
                    }
                }
                if (insertionOrder[i].type === 'Run of Channel') {
                    rocCount++;
                } else if (insertionOrder[i].type === 'Run of Site') {
                    rosCount++;
                } else {
                    fpCount++;
                }
            }
        },
        changeInsertionOrderIndex(index) {
            this.insertionOrderIndex = index;
            this.progress = this.getProgress();
        },
        getProgress() {
            let dates = this.insertionOrder.dates;
            let firstDate = null;
            let lastDate = null;
            for (let i = 0; i < dates.length; i++) {
                let start = moment(dates[i].start, 'YYYY-MM-DD');
                let end = moment(dates[i].end, 'YYYY-MM-DD');
                if (i === 0) {
                    firstDate = start;
                    lastDate = end;
                } else {
                    if (start.isBefore(firstDate, 'date')) {
                        firstDate = start;
                    }
                    if (end.isAfter(lastDate, 'date')) {
                        lastDate = end;
                    }
                }
            }
            let today = moment();
            if (today.isAfter(lastDate, 'date')) {
                return 100;
            } else if (lastDate.isSame(firstDate, 'date')) {
                if (firstDate.isSame(today, 'date')) {
                    return 50;
                } else {
                    return 0;
                }
            } else {
                const diffDays = lastDate.diff(today, 'days');
                const diffDays2 = lastDate.diff(firstDate, 'days');
                return ((diffDays2 - diffDays) / diffDays2 * 100);
            }
        },
        alert: function (string) {
            if (typeof string !== "undefined") {
                this.$noty.success(string);
            }
        },
        updateComment(comment) {
            this.comment = comment
        },
        fetchTrackingList() {
            this.formulaReady = false;
            this.$store.dispatch('trackingList/fetch', this.vuexState.campaign.campaign.mediums[this.mediumIndex].tracking_list_id).then(() => {
                this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                    this.mediumChangePending = false;
                    this.formulaReady = true;
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>

.kpiContainer {
    width: 100%;
    display: flex;
    flex-flow: wrap;
}

.kpiWrapper {
    width: calc(100% / 4);
    padding: 10px;

    &.large {
        width: calc((100% / 4) * 2);
    }
}

@media (min-width: 768px) and (max-width: 1300px) {
    .kpiWrapper {
        width: calc(100% / 3);
        padding: 10px;

        &.large {
            width: calc(100% / 3);
        }
    }
}

@media (max-width: 767px) {
    .kpiWrapper {
        width: 100vw;
        margin-left: -1rem;
        margin-right: -1rem;

        &.large {
            width: 100vw;
            margin-left: -1rem;
            margin-right: -1rem;
        }
    }

    .progressbar-wrapper {
        width: 100vw;
        margin-left: -2rem;
    }
}

.progressbar-wrapper {
    background: #fff;
    padding: 1rem;
    margin-top: 1rem;
}

.progress-infos {
    margin-bottom: 1rem;
}

.v-dot {
    margin: auto !important;
}

.loaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10em;
}

.slider-info {
    bottom: 0;
    position: absolute;
    left: 46.5%;
    font-size: 1.3em;
}

.slider-insertion-header {
    font-weight: normal;
    font-size: .9em;
    padding-top: 1em;
}

.carousel-3d-slide.current > .slider-insertion-header {
    padding-top: 1.5em;
}

.carousel-3d-slide > .current-text {
    display: block;
    visibility: hidden;
}

.carousel-3d-slide.current > .current-text {
    display: block;
    visibility: visible;
    padding-bottom: .3em;
}

.current-text-main {
    display: block;
}

.carousel-3d-slide {
    display: block;
}

.campaign-status {
    float: right;
}

.campaign-progress {
    font-weight: bold;
}


.dashboardContent {
    margin: auto;
}

.attachment-container {
    margin-top: 1rem;
}

.tabbar {
    margin-top: -5.25em;
    margin-bottom: 3.2em;
}

@media (max-width: 1199px) {
    .dashboardContent {
        padding: 1rem;
    }
}

@media only screen and (max-width: 767px) {

    .tabbar {
        margin-top: -4em;
        width: 100vw;
        margin-left: -1rem;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .tabbar {
        margin-top: -4em;
    }
}

@media (min-width: 1025px) and (max-width: 1199px) {
    .tabbar {
        margin-top: -4.3em;
    }
}
</style>